<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="6">
        <b-card class="picture-div">
          <LoadingCard v-if="loadingData"></LoadingCard>
          <div v-else>
            <div class="container">
              <img
                :src="partData.image"
                alt="fibernode.com"
                style="max-height:250px; display:block; margin: auto"
              />
            </div>
          </div>
        </b-card>
      </b-col>

      <b-col lg="6">
        <b-card class="information" header="data">
          <div
            slot="header"
            style="display:flex; justify-content: space-between;"
          >
            <HeaderTitle title="Information"></HeaderTitle>
          </div>
          <div style="min-height: 200px">
            <span class="title-details">
              Model :
              <b>{{ partData.model }}</b>
            </span>
            <span class="title-details">
              Manufacturer :
              <b>{{ partData.make }}</b>
            </span>
            <span class="title-details">
              Product Type :
              <b>{{ partData.type }}</b>
            </span>
            <span class="title-details">
              Product Family :
              <b>{{ partData.family }}</b>
            </span>
            <span class="title-details">
              Product Description :
              <b>{{ partData.desc }}</b>
            </span>
            <span class="title-details">
              Manufacturer Part Number :
              <b>{{ partData.man_part }}</b>
            </span>
          </div>
        </b-card>
      </b-col>
      <ActiveBacklogModel
        v-if="!loadingData"
        :lgSize="6"
        :part="part"
        :modelData="partData"
      ></ActiveBacklogModel>
      <DeliveredModel
        v-if="!loadingData"
        :lgSize="6"
        :part="part"
        :modelData="partData"
      ></DeliveredModel>
      <BERModel
        v-if="!loadingData"
        :lgSize="6"
        :part="part"
        :modelData="partData"
      ></BERModel>
      <WARModel
        v-if="!loadingData"
        :lgSize="6"
        :part="part"
        :modelData="partData"
      ></WARModel>
    </b-row>
  </div>
</template>

<script>
import ActiveBacklogModel from "../../../components/model-dashboard/ActiveBacklogModel.vue";
import DeliveredModel from "../../../components/model-dashboard/DeliveredEquipmentModel";
import BERModel from "../../../components/model-dashboard/BeyondEconomicalRepairModel";
import WARModel from "../../../components/model-dashboard/UnderWarrantyModel";
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import LoadingCard from "../../../components/shared/LoadingCard.vue";

export default {
  props: ["part"],
  name: "ModelDashboard",
  components: {
    ActiveBacklogModel,
    DeliveredModel,
    BERModel,
    WARModel,
    HeaderTitle,
    LoadingCard
  },
  data: function() {
    return {
      loadingData: true,
      loadingProps: false,
      partParam: "",
      partData: []
    };
  },
  methods: {
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        fns_part: this.part
      };
      this.$http.get("api/products/prodInfo.php", { params }).then(
        res => {
          this.partData = res.data[0];
          this.loadingData = false;
        },
        err => {
          console.log(err);
          this.loadingData = false;
        }
      );
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style>
.title-details {
  padding: 0.5em;
  padding-bottom: 0.2em !important;
  font-size: 1.1em;
  display: block;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
